import React from 'react';
import NearestEvent from './NearestEvent/NearestEvent';
import EventPreview from '../EventPreview/EventPreview';
import { Event } from '../Event.interface';
import { environments } from 'environments/environments';
import './UpcomingEvents.css'


export default class UpcomingEvents extends React.Component {
  state = {
    events: [] as Event[],
    loading: false,
    error: false
  }

  mounted = false;
  controller = new AbortController();

  componentDidMount() {
    this.getEventsFromDB();
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
    this.controller.abort();
  }

  /** Loads event list from database. Only loads future events. */
  getEventsFromDB() {
    this.setState({ events: [], loading: true, error: false });
    const params = `?t=events&count=0&order=eventtime&asc=1&c=eventtime>${Date.now()}`;
    fetch(environments.server + environments.backend + params, { signal: this.controller.signal }).then(
      async (result: any) => {
        const dbEvents = await result.json();
        // console.log(dbEvents);
        if (dbEvents && dbEvents.length) {
          const events: Event[] = dbEvents.map((event: any) => {
            const guests = (event.guests || '').replace(/&quot;/g, '"').replace(/&apos;/g, '\'').split(';');
            const modifiedEvent: Event = { ...event, guests };
            return modifiedEvent;
          });
          this.setState({ events: events, loading: false, error: false });
        } else {
          this.setState({ events: [], loading: false, error: false });
        }
      }
    ).catch(e => {
      if (this.mounted) {
        this.setState({ events: [], error: true, loading: false })
      }
    })
  }

  render() {
    const renderEvents = this.state.events.map((event, index) => index ? <EventPreview key={index} event={event} /> : null)

    return (<div className='UpcomingEvents'>
      <span className="current-event">Nejbližší akce</span>
      {this.state.loading
        ? <p className='loading-info'><span className="loading loading-spinner"></span> Načítá se seznam nadcházejících akcí...</p>
        : this.state.error
          ? <p className='loading-error'>
            Nepovedlo se načíst seznam nadcházejících akcí, zkusit <span onClick={() => this.getEventsFromDB()}>ZNOVU</span>?
          </p>
          : this.state.events && this.state.events[0]
            ? <div className="section">
              <NearestEvent event={this.state.events[0]} />
              {this.state.events[1]
                ? <div>
                  <span className="current-event">Další akce</span>
                  {renderEvents}<br />
                </div>
                : null}
            </div>
            : <p className='nothing'>V nejbližší době není plánovaná žádná akce. Zůstaňte na příjmu.</p>}
    </div>);
  }
}